import { reactive, toRefs, Ref, ref, watch, onMounted } from '@vue/composition-api';

import debounce from 'lodash/debounce';

export function useForm(element: Ref<any>, rules: { [key: string]: any }) {
    const state = reactive({
        valid: true,
        //rules: options.rules,
        isSaving: false,
    });

    const validate = () => {
        //@ts-ignore
        return element.value.validate();
    };

    const revalidate = () => {
        //@ts-ignore
        return setTimeout(() => validate(), 0);
    };

    const reset = () => {
        if (element && element.value) {
            //@ts-ignore
            element.value.reset();
        }
    };

    const resetValidation = () => {
        if (element && element.value) {
            //@ts-ignore
            element.value.resetValidation();
        }
    }

    const saveForm = async <T>(savefn: () => Promise<T>): Promise<T> => {
        if (!state.isSaving && validate()) {
            state.isSaving = true;
            const res = await savefn();
            state.isSaving = false;
            return res;
        }
        return null;
    };

    return reactive({
        ...toRefs(state),
        element,
        rules,
        validate,
        revalidate,
        reset,
        resetValidation,
        saveForm,
    });
}

interface FormOptions {
    rules: { [key: string]: any };
    element: Ref<string>;
}

export function useAsyncValidation(model: () => any, validationFn: (value: any) => Promise<boolean | string>) {
    const errors = ref([]);

    const debouncedFn = debounce(async (value) => {
        const res = await validationFn(value);
        if (res != null && typeof res == 'string') {
            errors.value = [res];
        } else {
            errors.value = [];
        }
    }, 300);

    watch(
        () => model(),
        () => {
            debouncedFn(model());
        }
        // { lazy: true }
    );

    return errors;
}

export function useSetFocusOnLoad(delay: number = 0) {
    const setFocuseTo = ref('');

    onMounted(() => {
        setTimeout(() => {
            //@ts-ignore
            setFocuseTo.value.focus();
        }, delay);
    });

    return setFocuseTo;
}

export function useSetFocusOnActive(activePropertyFn: () => any) {
    const textRef = ref<HTMLElement | { $el: HTMLElement }>(null);
    onMounted(() => {
        watch(
            () => activePropertyFn(),
            (current) => {
                if (current) {
                    setTimeout(() => {
                        if (activePropertyFn()) {
                            if ('$el' in textRef.value) {
                                textRef.value.$el.focus();
                            } else {
                                textRef.value.focus();
                            }
                        }
                    }, 200);
                }
            },
            {
                immediate: true,
            }
        );
    });

    return textRef;
}
